export const WITHDRAWAL_VALIDATION_RULES = {
  memberIdentifier: {
    isRequiredTrim: {
      value: true,
    },
  },
  memberEmail: {
    isRequiredTrim: {
      value: true,
    },
    regex: {
      value: {
        pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        customMessageKey: "validation.customMessages.emailAddressRegex",
      },
    },
  },
  confirmEmail: {
    isRequiredTrim: {
      value: true,
    },
    mustMatch: {
      value: {
        field: "memberEmail",
        customMessageKey: "validation.customMessages.emailAddressMatch",
      },
    },
  },
  isInactiveReason: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "withdrawal.messages.validation.withdrawalMethod",
    },
  },
  withdrawalCoveragesSelection: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "isInactiveReason",
        expectedValues: ["ANNUAL_DEACTIVATION","SESSION_DEACTIVATION"],
        customMessageKey: "withdrawal.messages.validation.withdrawalSelection",
      },
    },
  },
  verificationResponse: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "withdrawal.messages.validation.verificationCode",
      pushErrorToField: "verificationCode",
    },
  },
  haveRead: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  acceptance: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  legalUnbinding: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  understanding: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  withdrawFromTheRegime: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  gRecaptchaResponse: {
    isRequiredTrim: {
      customErrorLevel: "form",
      value: true,
      customMessageKey: "validation.customMessages.recaptcha",
    },
  },
};

export const INSTITUTIONAL_EMAIL_VALIDATION_RULES = {
  confirmInstitutionalEmail: {
    mustMatch: {
      value: {
        field: "memberEmail",
        customMessageKey:
          "withdrawal.messages.validation.confirmInstitutionalEmail",
      },
      pushErrorToField: "memberEmail",
    },
  },
};

export const REFUND_VALIDATION_RULES = {
  refundMethod: {
    isRequiredTrim: {
      customErrorLevel: "form",
      value: true,
      customMessageKey: "withdrawal.messages.validation.refundMethod",
    },
  },
  bankTransit: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "refundMethod",
        expectedValues: ["DEPOSIT_REFUND"],
      },
    },
    regex: {
      value: {
        pattern: /^$|^\d{5}$/i,
        customMessageKey: "validation.customMessages.banking.transitNumber",
      },
    },
  },
  bankInstitution: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "refundMethod",
        expectedValues: ["DEPOSIT_REFUND"],
      },
    },
    regex: {
      value: {
        pattern: /^$|^\d{3}$/i,
        customMessageKey: "validation.customMessages.banking.institutionNumber",
      },
    },
  },
  bankAccount: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "refundMethod",
        expectedValues: ["DEPOSIT_REFUND"],
      },
    },
    regex: {
      value: {
        pattern: /^$|^\d{5,12}$/i,
        customMessageKey: "validation.customMessages.banking.accountNumber",
      },
    },
  },
  bankAccountOwnerName: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "refundMethod",
        expectedValues: ["DEPOSIT_REFUND"],
      },
    },
    regex: {
      value: {
        pattern: /^$|^(?=.*\S).+$/,
        customMessageKey:
          "validation.customMessages.banking.bankAccountOwnerName",
      },
    },
  },
  bankCheckDigit: {
    regex: {
      value: {
        pattern: /^$|^\d{1}$/i,
        customMessageKey: "validation.customMessages.banking.bankCheckDigit",
      },
    },
  },
  bankAccountOwner: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "refundMethod",
        expectedValues: ["DEPOSIT_REFUND"],
        customMessageKey: "withdrawal.messages.validation.acceptCondition",
      },
    },
  },
  correctBankInfo: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "refundMethod",
        expectedValues: ["DEPOSIT_REFUND"],
        customMessageKey: "withdrawal.messages.validation.acceptCondition",
      },
    },
  },
};

export const DESJARDINS_REFUND_VALIDATION_RULES = {
  bankAccount: {
    isRequiredTrimIfFieldHasValue: {
      value: {
        field: "refundMethod",
        expectedValues: ["DEPOSIT_REFUND"],
      },
    },
    regex: {
      value: {
        pattern: /^$|^\d{7}$/i,
        customMessageKey:
          "validation.customMessages.banking.accountNumberSevenDigit",
      },
    },
  },
};

export const ALL_WITHDRAWAL_VALIDATION_RULES = {
  ...WITHDRAWAL_VALIDATION_RULES,
  ...INSTITUTIONAL_EMAIL_VALIDATION_RULES,
  ...REFUND_VALIDATION_RULES,
};



// WEBPACK FOOTER //
// ./src/components/withdrawal/withdrawalValidationRules.js